// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 3.25rem;
  min-height: 3.25rem;
  padding: 0 1.25rem;
  background: var(--surface-primary);
  border-bottom: 1px solid var(--border-default);
  z-index: 50;
}

.top-bar-left {
  display: flex;
  align-items: center;
}
.top-bar-left .page-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/top-bar/top-bar.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,8CAAA;EACA,WAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;AACE;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;AACJ","sourcesContent":[".top-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 3.25rem;\n  min-height: 3.25rem;\n  padding: 0 1.25rem;\n  background: var(--surface-primary);\n  border-bottom: 1px solid var(--border-default);\n  z-index: 50;\n}\n\n.top-bar-left {\n  display: flex;\n  align-items: center;\n\n  .page-title {\n    font-size: 1rem;\n    font-weight: 700;\n    color: var(--text-primary);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
